<div class="form-title-container">
  <h3>Datos generales</h3>
</div>
<div class="columns is-multiline" [formGroup]="identificationForm" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
  <div
    [ngClass]="
      identificationForm.get('personType')?.value === 'PHYSICAL_PERSON'
        ? 'column is-4 form-container'
        : 'column is-12 form-container'
    "
  >
    <span class="label">{{
      identificationForm.get("personType")?.value === "PHYSICAL_PERSON"
        ? "Nombre"
        : "Razón social"
    }}</span>
    <input
      class="search-input"
      type="text"
      pInputText
      formControlName="name"
      style="text-transform: uppercase"
    />
  </div>
  @if (identificationForm.get("personType")?.value === "PHYSICAL_PERSON") {
    <div class="column is-4 form-container">
      <span class="label">Primer apellido</span>
      <input
        class="search-input"
        type="text"
        pInputText
        formControlName="firstSurname"
        style="text-transform: uppercase"
      />
    </div>
    <div class="column is-4 form-container">
      <span class="label">Segundo apellido</span>
      <input
        class="search-input"
        type="text"
        pInputText
        formControlName="secondSurname"
        style="text-transform: uppercase"
      />
    </div>
  }
  <div class="column is-4 form-container">
    <span class="label">Código Cliente</span>
    <p-inputNumber
      [useGrouping]="false"
      class="search-input"
      formControlName="code"
      (onBlur)="onCodeBlur()"
    />
    @if (codeAlreadyExists) {
      <small class="p-error">Este código de cliente ya está en uso</small>
    }
  </div>
  <ng-container
    *ngIf="identificationForm.get('personType')?.value === 'JURIDIC_PERSON'"
  >
    <div class="column is-4 form-container">
      <span class="label">Código aplicación laboral</span>
      <input
        class="search-input"
        type="text"
        pInputText
        formControlName="codeApplication"
      />
    </div>
    <div class="column is-4 form-container">
      <span class="label">Tipo cliente</span>
      <p-dropdown
        [options]="clientConstants.COMPANY_TYPES"
        optionLabel="label"
        optionValue="value"
        [placeholder]="snapshotData ? '' : 'Seleccionar tipo de cliente'"
        formControlName="companyType"
      />
    </div>
  </ng-container>

  <!-- <div class="column is-4 form-container">
        <span class="label">Código Aplicación</span>
        <input class="search-input" type="text" pInputText formControlName="codeApplication"/>
    </div>
    <div class="column is-4 form-container">
        <span class="label">Aplicación</span>
        <input class="search-input" type="text" pInputText formControlName="application"/>
    </div> -->
  <!-- <div class="column is-4 form-container">
        <span class="label">Tipo de cliente</span>
        <p-dropdown [options]="clientConstants.CLIENT_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de cliente" formControlName="personType" />
    </div>
    <div class="column is-4 form-container">
        <span class="label">Tipo documento</span>
        <p-dropdown [options]="clientConstants.DOCUMENT_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de documento" formControlName="documentType"/>
    </div>
    <div class="column is-4 form-container">
        <span class="label">Número de documento identidad</span>
        <input class="search-input" type="text" pInputText formControlName="documentNumber"/>
    </div>
    <div class="column is-4 form-container">
        <span class="label">Fecha de caducidad</span>
        <p-calendar [iconDisplay]="'input'"  dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="documentCaducityDate"/>
    </div> -->
  <ng-container
    *ngIf="identificationForm.get('personType')?.value === 'PHYSICAL_PERSON'"
  >
    <div class="column is-4 form-container">
      <span class="label">{{
        identificationForm.get("personType")?.value === "PHYSICAL_PERSON"
          ? "Fecha de nacimiento"
          : "Fecha de constitución"
      }}</span>
      <p-calendar
        [iconDisplay]="'input'"
        dateFormat="dd/mm/yy"
        dataType="date"
        [showIcon]="true"
        inputId="icondisplay"
        formControlName="constitutionDate"
      />
    </div>
    <div class="column is-4 form-container">
      <p-checkbox
        formControlName="residenceCertificate"
        binary="true"
        inputId="residenceCertificate_physical"
      />
      <label for="residenceCertificate_physical">Certificado residencia</label>
    </div>
    @if (identificationForm.get("personType")?.value === "PHYSICAL_PERSON") {
      <div class="column is-4 form-container">
        <span class="label">Nombre de representante</span>
        <p-dropdown
          [options]="representativeOptions()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="snapshotData ? '' : 'Seleccionar cliente relacionado'"
          formControlName="representative"
          filterBy="name"
          [filter]="true"
          [emptyFilterMessage]="'No se encontraron resultados'"
        />
      </div>
      <div class="column is-4 form-container">
        <span class="label">NIF Representante</span>
        <input
          class="search-input"
          type="text"
          pInputText
          formControlName="representativeNif"
          placeholder="NIF"
        />
      </div>
      <!-- TODO ACTIVAR ESTO CUANDO LAS OBSERVACIONES SEAN NECESARIAS -->
      <!-- <div class="column is-8 form-container">
            <span class="label">Observaciones</span>
            <input class="search-input" type="text" pInputText formControlName="observations" style="text-transform: uppercase;"/>
        </div> -->
    }
  </ng-container>
  <ng-container
    *ngIf="identificationForm.get('personType')?.value === 'JURIDIC_PERSON'"
  >
    <div class="column is-4 form-container">
      <p-checkbox
        formControlName="residenceCertificate"
        binary="true"
        inputId="residenceCertificate_juridic"
      />
      <label for="residenceCertificate_juridic">Certificado residencia</label>
    </div>
    <!-- <div class="column is-8 form-container">
            <span class="label">Observaciones</span>
            <input class="search-input" type="text" pInputText formControlName="observations" style="text-transform: uppercase;"/>
        </div> -->
  </ng-container>
  <!-- <div class="column is-4 form-container">
        <span class="label">Responsable Interno</span>
        <p-dropdown [options]="responsibleUsers" optionLabel="name" optionValue="id" placeholder="Seleccionar responsable" formControlName="responsible"/>
    </div> -->
  @if (
    identificationForm.value.relationType === "NO_RECURRENT" ||
    identificationForm.value.relationType === "NO_CLIENT"
  ) {
    <div class="column is-4 form-container">
      <p-checkbox
        formControlName="socialCollaboratorAuthorization"
        binary="true"
        inputId="socialCollaboratorAuthorization"
      />
      <label for="socialCollaboratorAuthorization"
        >Autorización colaborador social</label
      >
    </div>
  }
</div>

<!-- <div class="form-title-container">
        <h3>Aplicaciones</h3>
    </div>
    <div class="columns is-multiline">
        @for(app of applications.controls; track app; let i = $index) {
            <div class="column is-2 form-container"  [formGroup]="app">
                <span class="label">{{ app.get('name')?.value }}</span>
                <input class="search-input" type="text" pInputText formControlName="code"/>
            </div>
        }
    </div>
    <div class="column is-12">
       
    </div> -->
<div class="form-title-container is-fullwidth">
  <h3>Documentos</h3>
  @if (hasEditPermission) {
    <a class="button add-button" (click)="openDocumentFormModal()"
      >Añadir documento</a
    >
  }
</div>
@if (configTable) {
  <div class="card">
    <app-clients-table
      [configTable]="activeDocumentsTableConfig"
      [snapshotMode]="!!snapshotData"
      (openItemEvent)="openDocumentFormModal($event)"
      (deleteItemEvent)="openDocumentConfirmModal($event)"
    ></app-clients-table>
  </div>
}

@if (
  identificationForm.get("personType")?.value === "PHYSICAL_PERSON" &&
  (
    identificationForm.get("relationType")?.value === "RECURRENT" ||
    identificationForm.get("relationType")?.value === "NO_RECURRENT" ||
    identificationForm.get("relationType")?.value === "NO_CLIENT"
  )
) {
  <div
    class="form-title-container is-fullwidth"
    [ngStyle]="{ 'margin-top': '40px' }"
  >
    <h3>Personas vinculadas</h3>
    @if (hasEditPermission) {
      <a class="button add-button" (click)="openFormModal()">Añadir persona</a>
    }
  </div>
  @if (configTable) {
    <div class="card">
      <app-clients-table
        [configTable]="activeRelatedPersonsTableConfig"
        [snapshotMode]="!!snapshotData"
        (executeActionEvent)="goToRelatedPersonDetail($event)"
        (openItemEvent)="openFormModal($event)"
        (deleteItemEvent)="openConfirmModal($event)"
      ></app-clients-table>
    </div>
  }
}

<div
  class="columns is-multiline"
  [formGroup]="identificationForm"
  [ngStyle]="{ 'margin-top': '40px' }"
>
  <div class="column is-12 form-container">
    <span class="label">Observaciones</span>
    <textarea
      pInputTextarea
      [autoResize]="true"
      formControlName="comment"
      rows="3"
      class="search-input observations-field"
      maxlength="2000"
    ></textarea>
  </div>
</div>

<div class="columns" style="margin-bottom: 100px">
  <div class="column is-12"></div>
</div>

<!-- <div class="column is-6 form-container">
        <span class="label">Fecha de nacimiento / Constitución</span>
        <p-calendar [iconDisplay]="'input'"  dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="constitutionDate"/>
    </div> -->
<!-- <div class="column is-6 form-container">
        <span class="label">Fecha de alta</span>
        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"  dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startDate"/>
    </div> -->
<!-- @if (clientId) {
        <div class="column is-6 form-container">
            <span class="label">Fecha de baja</span>
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"  dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="endDate"/>
        </div>
    } -->
@if (!hidePersistenceUi) {
<div class="save-button-container">
  @if (identificationForm.get("state")?.value === ClientState.Pending) {
    <button
      class="button save-button is-secondary is-outlined"
      (click)="saveClientAsDraft()"
      [disabled]="isSavingClient"
    >
      <fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar
    </button>
    <button
      class="button save-button is-secondary"
      (click)="openFinishClientModal()"
      [disabled]="isSaving"
    >
      <fa-icon class="save-icon" [icon]="faCheck"></fa-icon> Finalizar alta
    </button>
  } @else {
    <button class="button save-button is-secondary" (click)="save()" [disabled]="isSavingClient">
      <fa-icon class="save-icon" [icon]="faFloppyDisk"></fa-icon> Guardar
    </button>
  }
  @if (client && hasEditPermission && clientId) {
    @if (client.state === "ACTIVE") {
      <button
        class="button deactivate-button"
        (click)="openDeactivationModal()"
      >
        Dar de baja
      </button>
    } @else if (client.state === "INACTIVE") {
      <button
        class="button reactivate-button"
        (click)="openDeactivationModal()"
      >
        Reactivar
      </button>
    }
  }
</div>
}

<div class="modal" [class.is-active]="isModalActive">
  <div class="modal-background" (click)="isModalActive = false"></div>
  <div class="modal-card">
    <form [formGroup]="modalForm" (ngSubmit)="saveItem()">
      <header class="modal-card-head">
        @if (isCreating) {
          <p class="modal-card-title">Nueva persona vinculada</p>
        } @else {
          <p class="modal-card-title">Editar persona vinculada</p>
        }
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">Nombre</label>
          <p-dropdown
            [options]="representativeOptions()"
            optionLabel="name"
            optionValue="id"
            placeholder="Seleccionar persona"
            formControlName="person"
            filterBy="name"
            [filter]="true"
            [emptyFilterMessage]="'No se encontraron resultados'"
          />
        </div>
        <div class="field">
          <label class="label">Tipo</label>
          <p-dropdown
            [options]="clientConstants.RELATED_PERSON_TYPES"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccionar tipo de persona"
            formControlName="type"
          />
        </div>
        @if (modalForm.get("type")?.value === "SPOUSE") {
          <div class="field">
            <label class="label">Tipo de cónyuge</label>
            <p-dropdown
              [options]="clientConstants.SPOUSE_TYPES"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar tipo de cónyuge"
              formControlName="spouseType"
            />
          </div>
          @if (modalForm.get("spouseType")?.value === "MARRIED") {
            <div class="field">
              <label class="label">Régimen matrimonial</label>
              <input class="input" formControlName="maritalStatus" />
            </div>
          }
          @if (modalForm.get("spouseType")?.value === "COMMON_LAW") {
            <div class="field">
              <p-checkbox
                formControlName="isRegistered"
                binary="true"
                inputId="isRegistered"
              />
              <label for="isRegistered">Inscrita</label>
            </div>
          }
          <div class="field">
            <label class="label">Fecha de cónyuge</label>
            <p-calendar
              [iconDisplay]="'input'"
              dateFormat="dd/mm/yy"
              dataType="date"
              [showIcon]="true"
              inputId="icondisplay"
              formControlName="date"
            />
          </div>
        }
      </section>
      @if (submitError) {
        <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
      }
      <footer class="modal-card-foot buttons-container">
        <ng-container *ngIf="snapshotData; else personEditButtons">
          <button type="button" class="button cancel-button" (click)="isModalActive = false">Cerrar</button>
        </ng-container>
        <ng-template #personEditButtons>
          <button class="button cancel-button" (click)="isModalActive = false">
            Cancelar
          </button>
          <button
            class="button save-button"
            type="submit"
            [disabled]="!modalForm.valid"
          >
            Guardar
          </button>
        </ng-template>
      </footer>
    </form>
  </div>
</div>

<div class="modal" [class.is-active]="isDocumentModalActive">
  <div class="modal-background" (click)="isDocumentModalActive = false"></div>
  <div class="modal-card">
    <form [formGroup]="documentModalForm" (ngSubmit)="saveDocument()">
      <header class="modal-card-head">
        @if (isCreatingModal) {
          <p class="modal-card-title">Nuevo documento</p>
        } @else {
          <p class="modal-card-title">Editar documento</p>
        }
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">Tipo</label>
          <p-dropdown
            [options]="clientConstants.DOCUMENT_TYPES"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccionar tipo de documento"
            formControlName="type"
          />
        </div>
        <div class="field">
          <label class="label">Número</label>
          <input
            class="input"
            formControlName="number"
            style="text-transform: uppercase"
          />
          @if (documentDuplicateError) {
            <p class="help is-danger" data-testid="doc-duplicado">Ya existe un documento del mismo tipo con este número.</p>
          }
          <div
            class="help is-danger"
            *ngIf="
              documentModalForm.get('number')?.invalid &&
              (documentModalForm.get('number')?.dirty ||
                documentModalForm.get('number')?.touched)
            "
          >
            Número inválido
          </div>
        </div>
        <div
          class="field"
          *ngIf="documentModalForm.get('type')?.value === 'NIE'"
        >
          <label class="label">Número de soporte</label>
          <input
            class="input"
            formControlName="supportNumber"
            style="text-transform: uppercase"
          />
        </div>
        <div class="field">
          <label class="label">Fecha de caducidad</label>
          <p-calendar
            [iconDisplay]="'input'"
            dateFormat="dd/mm/yy"
            dataType="date"
            [showIcon]="true"
            inputId="icondisplay"
            formControlName="caducityDate"
          />
        </div>
        <div class="field">
          <p-checkbox
            formControlName="principal"
            [binary]="true"
            inputId="principal"
            [disabled]="principalExists && !isEditingPrincipalDocument"
          />
          <label for="principal">Documento principal</label>
        </div>
      </section>
      @if (submitError) {
        <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
      }
      <footer class="modal-card-foot buttons-container">
        <ng-container *ngIf="snapshotData; else documentEditButtons">
          <button type="button" class="button cancel-button" (click)="isDocumentModalActive = false">Cerrar</button>
        </ng-container>
        <ng-template #documentEditButtons>
          <button
            class="button cancel-button"
            (click)="isDocumentModalActive = false"
          >
            Cancelar
          </button>
          <button
            class="button save-button"
            type="submit"
            [disabled]="!documentModalForm.valid"
          >
            Guardar
          </button>
        </ng-template>
      </footer>
    </form>
  </div>
</div>

<div class="delete-modal" [class.is-active]="isConfirmModalActive">
  <div class="delete-modal-background" (click)="onCloseConfirmModal()"></div>
  <div class="delete-modal-content">
    <h1 class="delete-modal-title">Eliminar persona vinculada</h1>
    <div class="delete-modal-body">
      <div class="column is-12">
        <span> ¿Está seguro/a que desea eliminar la persona vinculada? </span>
      </div>
      @if (submitError) {
        <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
      }
      <div class="delete-modal-buttons">
        <button
          class="button is-outlined cancel-button"
          (click)="onCloseConfirmModal()"
        >
          Cancelar
        </button>
        <button
          class="comment-button button is-pulled-right"
          (click)="onConfirmDelete()"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="delete-modal" [class.is-active]="isDocumentConfirmModalActive">
  <div
    class="delete-modal-background"
    (click)="onDocumentCloseConfirmModal()"
  ></div>
  <div class="delete-modal-content">
    <h1 class="delete-modal-title">Eliminar documento</h1>
    <div class="delete-modal-body">
      <div class="column is-12">
        <span> ¿Está seguro/a que desea eliminar el documento? </span>
      </div>
      @if (submitError) {
        <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
      }
      <div class="delete-modal-buttons">
        <button
          class="button is-outlined cancel-button"
          (click)="onDocumentCloseConfirmModal()"
        >
          Cancelar
        </button>
        <button
          class="comment-button button is-pulled-right"
          (click)="onConfirmDocumentDelete()"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" [class.is-active]="isFinishClientModalActive">
  <div class="modal-background" (click)="onCloseFinishClientModal()"></div>
  <div class="modal-content">
    <h1 class="title">Finalizar alta</h1>
    <div class="select-container columns">
      <div class="column is-12">
        <span> ¿Está seguro/a que desea finalizar la alta del cliente? </span>
      </div>
      <div class="buttons-container">
        <button
          class="button is-outlined cancel-button"
          (click)="onCloseFinishClientModal()"
        >
          Cancelar
        </button>
        <button
          class="comment-button button is-pulled-right"
          (click)="onFinishClient()"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>

@if (showDeactivationModal) {
  <app-client-deactivation-modal
    [isReactivation]="client?.state === 'INACTIVE'"
    [isSaving]="isUpdatingState"
    [errorMessage]="deactivationError"
    (cancelEvent)="closeDeactivationModal()"
    (confirmEvent)="onDeactivationConfirm($event)"
  ></app-client-deactivation-modal>
}

@if (saveError) {
  <div class="notification is-danger">
    <button class="delete" (click)="saveError = ''"></button>
    <div class="notification-text">{{ saveError }}</div>
  </div>
}

@if (isSaved) {
  <div class="notification is-success">
    <!-- <button class="delete" (click)="isSaved = false"></button> -->
    <div class="notification-text">Guardado correctamente.</div>
    <div class="progress-bar-container">
      <progress class="progress is-small" min="0" max="100"></progress>
    </div>
  </div>
}
